module.exports = __webpack_public_path__ + "img/icon-add-bonus.b4cf7b5a.svg";